import { api } from './client';

function query(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      search.set(key, String(value));
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function listWriters(params) {
  return api.get(`/admin/writers${query(params)}`);
}

export function listLeads(params) {
  return api.get(`/admin/leads${query(params)}`);
}

export function updateWriter(id, body) {
  return api.patch(`/admin/writers/${id}`, body);
}

export function createLead(body) {
  return api.post('/admin/leads', body);
}

export async function downloadCsv(path, fallbackName) {
  const response = await api.download(path);
  const blob = await response.blob();
  const header = response.headers.get('Content-Disposition') || '';
  const match = /filename=([^;]+)/.exec(header);
  const filename = (match ? match[1] : fallbackName).replace(/"/g, '');
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function writersCsvPath(params) {
  return `/admin/writers.csv${query(params)}`;
}

export function leadsCsvPath(params) {
  return `/admin/leads.csv${query(params)}`;
}
